import { render, staticRenderFns } from "./MenuStock.vue?vue&type=template&id=13158f73&"
import script from "./MenuStock.vue?vue&type=script&lang=js&"
export * from "./MenuStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports